export enum AdminSmartListFunctionType {
  setDefaultForAllUsers = 1,
  setDefaultForSpecificUsers = 2,
  applyCurrentColumnsToAllUsers = 3,
  applyCurrentColumnsToSpecificProfiles = 4,
  restoreColumnsToDefault = 5,
  addColumns = 6,
  deleteColumn = 7
}